import React from 'react';
import { Box, Typography } from '@mui/material';
import useBannerStyles from '../../styles/kozelDarkQuiz/banner';
import tap from '../../assets/images/kozel_dark_quiz/ecran1_tap.png';
import doze from '../../assets/images/kozel_dark_quiz/ecran_1_doze.png';
import logo from '../../assets/images/kozel_dark_quiz/logoDark.png';

const Banner: React.FC = () => {
  const bannerStyles = useBannerStyles();
  return (
    <Box className={bannerStyles.bannerContainer}>
      {/* Text Panel - stânga */}
      <Box className={bannerStyles.textPanel}>
        <Typography className={bannerStyles.mainText}>
          Găsește-ți
        </Typography>
        <Typography className={bannerStyles.brandText}>
          mixul ușor de <br /> băut!
        </Typography>
        <Box className={bannerStyles.logoContainer}>
          <img 
            src={logo} 
            alt="Kozel Dark Logo" 
            className={bannerStyles.logoImage}
          />
        </Box>
      </Box>

      {/* Doze - centru */}
      <Box className={bannerStyles.dozeContainer}>
        <img 
          src={doze} 
          alt="Kozel Doze" 
          className={bannerStyles.dozeImage}
        />
      </Box>

      {/* Țap - dreapta sus */}
      <Box className={bannerStyles.tapContainer}>
        <img 
          src={tap} 
          alt="Kozel Țap" 
          className={bannerStyles.tapImage}
        />
      </Box>
    </Box>
  );
};

export default Banner;